import React from 'react';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { store } from '../../store';
import Localization from '../Localization';
import Routing from '../Routing';
import { history } from '../../common/helpers/history';
import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Icon from '../../components/Icon';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ErrorHandler from '../ErrorHandler';

const App = () => (
  <DndProvider backend={HTML5Backend as any}>
    <Provider store={store}>
      <Localization>
        <ErrorHandler>
          <ConnectedRouter history={history}>
            <Routing />
            <ToastContainer
              position="bottom-right"
              autoClose={4000}
              closeButton={<div className="Toastify__close-button"><Icon icon="close" /></div>}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </ConnectedRouter>
        </ErrorHandler>
      </Localization>
    </Provider>
  </DndProvider>
);

export default Sentry.withProfiler(App);
